function localStorage() {
  function setItem(key, value) {
    try {
      if (!window.localStorage || !window.localStorage.setItem) {
        return value
      }
      window.localStorage.setItem(key, JSON.stringify(value))

      return value
    } catch (e) {
      return value
    }
  }

  function getItem(key) {
    try {
      if (!window.localStorage || !window.localStorage.getItem) {
        return key
      }

      return JSON.parse(window.localStorage.getItem(key))
    } catch (e) {
      return false
    }
  }

  return { setItem, getItem }
}

export default localStorage()
